import React, { useEffect } from "react";

import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import GlobalStyles from "@mui/material/GlobalStyles";
import Container from "@mui/material/Container";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import AOS from "aos";
import "aos/dist/aos.css";
import ListItemIcon from "@mui/material/ListItemIcon";
import List from "@mui/icons-material/Grading";
import Com from "@mui/icons-material/ConnectWithoutContact";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import AccessibilityNewIcon from "@mui/icons-material/AccessibilityNew";
import BorderClearIcon from "@mui/icons-material/BorderClear";
import NavPc from "./navPc";
import { Helmet } from "react-helmet";
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';




const text = [
  {
    logo: "/clients/MakłowicziSynowielogo.webp",
    company: "Makłowicz i Synowie sp. z o.o.",
    description: "Wspólne przedsięwzięcie biznesowe rodziny Makłowicz oraz FoodHub S.A. (poprzednio: Pamapol S.A.). Prężnie rozwijająca się spółka z branży FMCG, zajmująca się produkcją i dystrybucją produktów spożywczych na rynku krajowym oraz zagranicznym. Wchodzi w skład Grupy Kapitałowej FoodHub.",
    linkwww: "https://maklowiczisynowie.pl/"
  },
  {
    logo: "/clients/ajde_logo.webp",
    company: "Ajde! Robert Makłowicz",
    description: "Platforma e-commerce zajmująca się w szczególności sprzedażą książek autorstwa Pana Roberta Makłowicza oraz odzieży sygnowanej jego wizerunkiem.",
    linkwww: "https://maklowicz.sklep.pl/"
  },
  {
    logo: "",
    company: "Propinquus sp. z o.o",
    description: "Firma rodzinna, której wspólnikami są członkowie rodziny Makłowicz.Podmiot o charakterze inwestycyjno-operacyjnym, w szczególności zajmujący się zarządzaniem prawami do wizerunku oraz koordynujący współprace i kontakty biznesowe.",
    linkwww: "https://www.maklowicz.pl/"
  },
  {
     logo: "/clients/Bugenvillalogo.webp",
    company: "BugenVilla / Nada 22 d.o.o.",
    description: "Spółka deweloperska działająca na terenie Chorwacji. Zajmuje się całym procesem inwestycyjnym: od znalezienia i nabycia właściwej działki, poprzez sporządzenie projektu, uzyskanie odpowiednich pozwoleń i budowę, aż po sprzedaż nieruchomości. Spółka oferuje zarówno luksusowe wille jak i apartamenty.",
    linkwww: "https://bugenvilla.com/"
  },
  {
    logo: "/clients/grupaforma.webp",
    company: "Grupa Forma (Forma Szultk Oskar Paw Jakub sp.k.)",
    description: "Od ponad 30 lat jeden z liderów w zakresie kompleksowej realizacji wyposażenia wnętrz komercyjnych. Spółka o zasięgu międzynarodowym, posiadająca w swym portfolio pokaźną liczbę realizacji projektów dla dużych podmiotów gospodarczych - zarówno krajowych jak i zagranicznych.",
    linkwww: "https://www.grupaforma.com/"
  },
  {
    logo: "/clients/CHDLOGO.png",
    company: "Choluj Design s.c.",
    description: "Firma działająca w obszarze zarządzania nieruchomościami i projektowania architektonicznego. Oferuje usługi w zakresie projektowania architektonicznego, architektury wnętrz, oświetlenia, mebli, animacji, wizualizacji oraz modelowania 3D.",
    linkwww: "https://cholujdesign.com/"
  },

];

function PricingContent() {
  useEffect(() => {
    AOS.init({
      duration: 2000,
    });
  }, []);
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };


  return (

    <React.Fragment>
      <GlobalStyles
        styles={{ ul: { margin: 0, padding: 0, listStyle: "none" } }}
      />
      <CssBaseline />
      {/* Hero unit */}
      <main>
        <NavPc />

        {/* wyjustowac od po czlaej szerokosci, dac ikonki na czarno  */}
        <Container justify="center" maxWidth="sm">
          <br /><br /><br /><br />
          {text.map((card) => (
            <Card data-aos="fade-right" variant="" maxWidth="sm">
              <CardMedia

              />
             <a href={card.linkwww} target="__blank" rel="noopener noreferrer">
                <img src={card.logo} width={300} />
              </a>
              <CardContent>
                <Typography gutterBottom variant="h5" component="div">
                  {card.company}

                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                  {card.description}
                </Typography>
          

                
              </CardContent>
              <CardActions>
                <a href={card.linkwww} target="__blank" rel="noopener noreferrer">
                {card.linkwww}
              </a>
              </CardActions>
              <hr />
              <br /><br />
            </Card>

          ))}
        <br /><br />
          <br /><br />



          <Helmet>
            <title>Klienci</title>
            <meta name="description" content="Klienci" />
            <link
              rel="canonical"
              href="http://kmtlegal.pl/Klienci"
            />
          </Helmet>
        </Container>
      </main>
    </React.Fragment>
  );
}

export default function Pricing() {
  return <PricingContent />;
}
